import Image from "@Components/Image";
import config from "@Config/index";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./OffersTouchpoints.module.scss";

/**
 * The "Powered by amber+" attribution that sits at the right edge of an offers section
 * heading. Shared by the home rail, Payment Success and Booking Details so the three
 * headings can't drift apart.
 */
const PoweredByAmberPlus = () => (
  <div className={styles["powered-by"]}>
    <span className={styles["powered-by-label"]}>Powered by</span>
    <Image
      src={`${config.IMAGE_STATIC_URL}/images/amber-plus-logo.svg`}
      alt="amber plus"
      width={89}
      height={24}
      className={styles["powered-by-logo"]}
    />
  </div>
);

export default wrapperHOC(PoweredByAmberPlus, {
  componentName: "PoweredByAmberPlus",
  showForChina: true,
});
